import _ from 'lodash';

export default function formatOverride(input) {
  const value = (_.isString(input) && !_.isEmpty(input)) ? { id: input } : input;
  return { value };
}
